/**
 * The host adapter for the `app-access-dialog` client-side entity (ADR-034).
 * The executor (in `@fias/client-entities`) runs with only
 * `{ userId, archeId, holderId }`; the plugin renderer that mounted an arche
 * registers here the function that draws ITS access sheet, and the executor
 * reaches it by arche id. An arche with no mounted renderer answers
 * ACCESS_UNAVAILABLE.
 */

import type { AppAccessDialogHost, AppAccessDialogResult } from '@fias/client-entities';

type SheetHandler = (holderId: string) => Promise<AppAccessDialogResult>;

const handlers = new Map<string, SheetHandler>();

/** Called by the plugin renderer on mount; returns the unregister function. */
export function registerAccessSheet(archeId: string, handler: SheetHandler): () => void {
  handlers.set(archeId, handler);
  return () => {
    if (handlers.get(archeId) === handler) handlers.delete(archeId);
  };
}

export const appAccessDialogHost: AppAccessDialogHost = {
  async showAccessSheet({ archeId, holderId }) {
    const handler = handlers.get(archeId);
    if (!handler) {
      return {
        error: { code: 'ACCESS_UNAVAILABLE', message: 'Managing access is not available here' },
      };
    }
    return handler(holderId);
  },
};
